module.exports = __webpack_public_path__ + "img/location_on-black-18dp.a4368e89.svg";